import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { default as getCurrentColumnWidth } from './getCurrentColumnWidth';
import { CalendarLayoutColumnConstants } from '../constants';

export function shouldShowFullWeekDayName() {
    const { dateRangeType } = getSurfaceStore();
    const currentColumnWidth = getCurrentColumnWidth();

    if (dateRangeType === DateRangeType.Month) {
        return currentColumnWidth > CalendarLayoutColumnConstants.shouldShowFullDateName_MONTH;
    }
    return currentColumnWidth > CalendarLayoutColumnConstants.shouldShowFullDateName_WEEK;
}
